import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { IndividualDrilldownSummaryDto } from "../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualDrilldownSummaryDto";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import {useRecoilValue} from "recoil";
import {userRolesState} from "../../../State/user.Atom";
import {EE123PeopleRole_Edit} from "../../../Component/Common/Constants/UserRoles";

interface IndividualDrilldownRow {
    Id: number;
    IdNumber: string;
    EmployeeCode: string;
    FullName: string;
    Race: string;
    Gender: string;
    Disabled: string;
    OccupationalLevel: string;
    Position: string;
    Youth: string;
    Province: string;
    Actions: ActionType[];
}

interface IndividualDrilldownTable {
    columns: Array<TableColumn>;
    rows: Array<IndividualDrilldownRow>;
}

export function IndividualDrilldownMapper(dataObject: IndividualDrilldownSummaryDto[], onEdit: (id: number) => void): IndividualDrilldownTable {
    const userRoles = useRecoilValue(userRolesState);

    const columns = [
        { Header: 'ID Number', accessor: 'IdNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Full Name', accessor: 'FullName', id: 'FirstName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Race', accessor: 'Race', id: 'RaceId',Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Gender', accessor: 'Gender', id: 'GenderId', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Disabled', accessor: 'Disabled', id: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Occupational Level', accessor: 'OccupationalLevel', id: 'OccupationalLevelId', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Position', accessor: 'Position', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Youth', accessor: 'Youth', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Province', accessor: 'Province', id: 'ProvinceName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: IndividualDrilldownSummaryDto, index: number) => ({
            Id: item.individualId,
            IdNumber: item.identificationNumber,
            EmployeeCode: item.employeeCode,
            FullName: item.fullName,
            Race: item.raceName,
            Gender: item.genderName,
            Disabled: item.disabled ? 'Yes' : 'No',
            OccupationalLevel: item.occupationalLevelName,
            Position: item.position,
            Youth: item.isYouth ? 'Yes' : 'No',
            Province: item.provinceName,
            Actions:  [
                userRoles.includes(EE123PeopleRole_Edit)
                    ? {
                        key: index.toString(),
                        label: 'View/Edit',
                        action: () => onEdit(item.individualId),
                        icon: {
                            color: 'info',
                            name: 'edit',
                        },
                    }
                    : {
                        key: index.toString(),
                        label: 'View',
                        action: () => onEdit(item.individualId),
                        icon: {
                            color: 'info',
                            name: 'visibility',
                        },
                    },
            ]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}